import { render, staticRenderFns } from "./Assorted.vue?vue&type=template&id=0fdc4e18"
import script from "./Assorted.vue?vue&type=script&lang=js"
export * from "./Assorted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports